import colors from 'config/colors';

import { MaterialCommunityIconName } from 'types/icons';

export type TabBarKey =
  | 'new'
  | 'cooking'
  | 'scheduled'
  | 'prepared'
  | 'newAndCooking';

type TabBar = {
  labelKey: string;
  value: TabBarKey;
  iconName: MaterialCommunityIconName;
  color?: string;
};

export const TAB_BARS: Record<TabBarKey, TabBar> = {
  new: {
    labelKey: 'sideBar.tabBarSection.new',
    value: 'new',
    iconName: 'new-box',
    color: colors.ui.statuses.active,
  },
  cooking: {
    labelKey: 'sideBar.tabBarSection.cooking',
    value: 'cooking',
    iconName: 'fire',
    color: colors.ui.statuses.cooking,
  },
  newAndCooking: {
    labelKey: 'sideBar.tabBarSection.newAndCooking',
    value: 'newAndCooking',
    iconName: 'fire',
    color: colors.ui.statuses.active,
  },
  scheduled: {
    labelKey: 'sideBar.tabBarSection.scheduled',
    value: 'scheduled',
    iconName: 'calendar-blank',
    color: colors.ui.statuses.scheduled,
  },
  prepared: {
    labelKey: 'sideBar.tabBarSection.prepared',
    value: 'prepared',
    iconName: 'text-box-check',
    color: colors.ui.statuses.prepared,
  },
} as const;

export const TAB_BARS_LIST = Object.values(TAB_BARS);

export function getEffectiveTabBar(
  selectedTabBar: TabBarKey,
  screen: 'chef' | 'overview',
  cardViewOrganisation: 'classic' | 'split',
): TabBarKey {
  if (!Object.prototype.hasOwnProperty.call(TAB_BARS, selectedTabBar)) {
    return TAB_BARS.new.value;
  }

  if (
    screen === 'overview' &&
    selectedTabBar === TAB_BARS.newAndCooking.value
  ) {
    return TAB_BARS.new.value;
  }

  if (
    screen === 'chef' &&
    cardViewOrganisation === 'split' &&
    (selectedTabBar === TAB_BARS.new.value ||
      selectedTabBar === TAB_BARS.cooking.value)
  ) {
    return TAB_BARS.newAndCooking.value;
  }

  if (
    screen === 'chef' &&
    cardViewOrganisation === 'classic' &&
    selectedTabBar === TAB_BARS.newAndCooking.value
  ) {
    return TAB_BARS.new.value;
  }

  return selectedTabBar;
}
